export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * 날짜 문자열을 Date 객체로 반환합니다.
 *
 * @param date YYYY-MM-DD 포맷의 날짜 문자열을 사용해주세요.
 * @returns Date 객체를 반환합니다.
 * @description
 * new Date()는 타임존 정보가 없는 경우 UTC기준으로 생성합니다.
 * UTC기준의 날짜를 설정하게되는 경우 의도하지 않은 날짜로 설정될 수 있습니다.
 *
 * UTC 기준 - 시차를 가진 타임존의 경우 설정한 날짜보다 이전 일이 설정됩니다.
 * ex) PDT(UTC-7): new Date('2024-01-02') // 2024-01-01T15:00:00.000Z
 *
 * 전달한 인자의 일자로 설정하기 위해 현지 시간 기준으로 00:00:00으로 설정한 Date 객체를 반환합니다.
 * ex) PDT(UTC-7): new Date('2024-01-02 00:00:00') // 2024-01-02T00:00:00.000Z
 */
export function toLocalDate(date: string): Date {
  if (!DATE_REGEX.test(date)) {
    throw new Error('날짜 문자열은 YYYY-MM-DD 형식이어야 합니다.');
  }

  return new Date(`${date} 00:00:00`);
}
